import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import PortfolioHome from './home/home.jsx';
import Conocimientos from './conocimientos/conocimientos.jsx';
import ExpLaboral from './exp_laboral/exp-laboral.jsx';
import Proyectos from './proyectos/proyectos.jsx';
import Contacto from './contacto/contacto.jsx';
import ScrollToTop from './components/ScrollToTop.jsx';

function App() {
  // Estado global para idioma y modo oscuro
  const [language, setLanguage] = useState(() => {
    return localStorage.getItem('language') || 'es';
  });
  
  const [isDarkMode, setIsDarkMode] = useState(() => {
    return localStorage.getItem('darkMode') === 'true';
  });

  // Persistir idioma en localStorage
  useEffect(() => {
    localStorage.setItem('language', language);
  }, [language]);

  // Persistir modo oscuro en localStorage
  useEffect(() => {
    localStorage.setItem('darkMode', isDarkMode);
  }, [isDarkMode]);

  return (
    <Router>
      <ScrollToTop />
      <Routes>
        <Route 
          path="/" 
          element={
            <PortfolioHome 
              language={language}
              setLanguage={setLanguage}
              isDarkMode={isDarkMode}
              setIsDarkMode={setIsDarkMode}
            />
          } 
        />
        <Route 
          path="/conocimientos" 
          element={
            <Conocimientos 
              language={language}
              setLanguage={setLanguage}
              isDarkMode={isDarkMode}
              setIsDarkMode={setIsDarkMode}
            />
          } 
        />
        <Route 
          path="/experiencia" 
          element={
            <ExpLaboral 
              language={language}
              setLanguage={setLanguage}
              isDarkMode={isDarkMode}
              setIsDarkMode={setIsDarkMode}
            />
          } 
        />
        <Route 
          path="/proyectos" 
          element={
            <Proyectos 
              language={language}
              setLanguage={setLanguage}
              isDarkMode={isDarkMode}
              setIsDarkMode={setIsDarkMode}
            />
          } 
        />
        <Route 
          path="/contacto" 
          element={
            <Contacto 
              language={language}
              setLanguage={setLanguage}
              isDarkMode={isDarkMode}
              setIsDarkMode={setIsDarkMode}
            />
          } 
        />
      </Routes>
    </Router>
  );
}

export default App;
